// extracted by mini-css-extract-plugin
export var chip = "_ma-0";
export var icon = "_ma-1";
export var remove = "_ma-2";
export var removeIcon = "_ma-3";